export default {
  LIMIT_REACHED: 'Limit reached',
  NOT_SUFFICIENT_FUNDS: 'Not sufficient funds',
  OTHER_ERROR: 'Something went wrong',
};
